<template>
  <ReferenceComponentParentList
    :searchList="result"
    :componentType="componentType"
    :selectedIndex="selectedIndex"
    :isLast="isLast"
    class="reference-list_md"
    @onClick="onIdeaSelected"
    @onScroll="onScroll"
  >
    <template #header>
      <BaseSubHeading
        weight="600"
        size="medium"
        color="monochrome-06"
      >
        Ideas
      </BaseSubHeading>
    </template>

    <template #item="{ option }">
      <div class="reference-list__item-in">
        <span>
          <BaseSubHeading
            weight="400"
            size="medium"
            color="monochrome-06"
          >
            I-{{ option.sequenceNumber }}
          </BaseSubHeading>
        </span>

        <BaseSubHeading
          weight="400"
          size="medium"
          color="monochrome-07"
          className="reference-idea__title"
        >
          {{ option.title }}
        </BaseSubHeading>
      </div>
    </template>
  </ReferenceComponentParentList>
</template>

<script lang="ts">
import { mixins, Options } from "vue-class-component"
import { Action } from "s-vuex-class"

import ReferenceComponentListCommon from "@/components/Reference/helpers/ReferenceComponentListCommon"
import ReferenceComponentParentList from "@/components/Reference/helpers/ReferenceComponentParentList.vue"

import { FilterIdea, SearchIdeaResult, ServerResponse } from "@/models"
import { ReferenceType } from "@/plugins/extensions/ReferenceType"
import { Actions } from "@/store"
import { parsingServerResponseContent } from "@/utils"

const components = {
  ReferenceComponentParentList
}

/** Popup list of the #I reference: finds the current project's Ideas by number or title. */
@Options({
  name: "IdeaList",
  components
})
export default class extends mixins(ReferenceComponentListCommon) {
  @Action(Actions.SEARCH_IDEA) findIdeas: (
    filter: FilterIdea
  ) => Promise<ServerResponse<SearchIdeaResult>>

  componentType = ReferenceType.IDEA
  result: SearchIdeaResult[] = []
  isLast = true

  async created() {
    this.filter = FilterIdea.createDefault()
    this.filter.addSort("sequenceNumber", true)
    if (this.projectId) {
      this.filter.projectIds = [this.projectId]
    }
    this.searchAction = this.onSearchIdeas
  }

  onIdeaSelected(payload: SearchIdeaResult) {
    this.selectItem({
      item: payload,
      payload: {}
    })
  }

  queryUpdated(q) {
    this.filter.page = 1
    this.filter.q = q.substring(1)
    this.search()
  }

  async onSearchIdeas() {
    const serverResponse = await this.findIdeas(this.filter)
    if (!serverResponse) return
    this.result = parsingServerResponseContent({
      originalContent: this.result,
      serverResponseContent: serverResponse.content,
      numberOfPage: serverResponse.pageable.pageNumber
    })
    this.isLast = serverResponse.last
  }
}
</script>
